import { Params, ParamMap } from '@angular/router';
import { dateParamFormat } from 'src/shared/constants';
import * as moment from 'moment';

const END_DATE_KEY = 'ed';
const TIME_STAMP_END_KEY = 'ed';

export const toEndDateParams = (args: {
	endDate?: string | moment.Moment;
}): Params => ({
	[END_DATE_KEY]: args.endDate
		? moment(args.endDate, dateParamFormat).format(dateParamFormat)
		: undefined,
});

export const toEndDateListArgs = (paramMap: ParamMap): { endDate?: string } =>
	paramMap.has(END_DATE_KEY)
		? {
				endDate: paramMap.get(END_DATE_KEY),
		  }
		: undefined;

export const toEndParams = (args: {
	end?: string | moment.Moment;
}): Params => ({
	[END_DATE_KEY]: args.end
		? moment(args.end, dateParamFormat).format(dateParamFormat)
		: undefined,
});

export const toEndListArgs = (paramMap: ParamMap): { end?: string } =>
	paramMap.has(END_DATE_KEY)
		? {
				end: paramMap.get(END_DATE_KEY),
		  }
		: undefined;

export const toTimeStampEndParams = (args: {
	timestampRangeEnd?: string | moment.Moment;
}): Params => ({
	[TIME_STAMP_END_KEY]: args.timestampRangeEnd
		? moment(args.timestampRangeEnd, dateParamFormat).format(
				dateParamFormat
		  )
		: undefined,
});

export const toTimeStampEndListArgs = (
	paramMap: ParamMap
): { timestampRangeEnd?: string } =>
	paramMap.has(TIME_STAMP_END_KEY)
		? {
				timestampRangeEnd: paramMap.get(TIME_STAMP_END_KEY),
		  }
		: undefined;

export const toLastInvoiceDateParams = (args: {
	lastInvoiceDate?: string | moment.Moment;
}): Params => ({
	[TIME_STAMP_END_KEY]: args.lastInvoiceDate
		? moment(args.lastInvoiceDate, dateParamFormat).format(dateParamFormat)
		: undefined,
});

export const toLastInvoiceDateListArgs = (
	paramMap: ParamMap
): { lastInvoiceDate?: string } =>
	paramMap.has(TIME_STAMP_END_KEY)
		? {
				lastInvoiceDate: paramMap.get(TIME_STAMP_END_KEY),
		  }
		: undefined;
